import React from "react"
import {useStaticQuery, graphql } from "gatsby"
import { Container,Row,Col } from 'react-bootstrap'
import Img from "gatsby-image"


const Products = (props) =>{

	const query = useStaticQuery(graphql`
	query {
	jacketTV26:file(relativePath: { eq: "jacket_tv26.png" }) {
		childImageSharp {
		fixed(width: 900) {
			...GatsbyImageSharpFixed
		}
		}
	},
	jacket1100:file(relativePath: { eq: "jacket_1100.png" }) {
		childImageSharp {
		fixed(width: 900) {
			...GatsbyImageSharpFixed
		}
		}
	}
	}
	`)
  
	return(
    <div className="Products">
    <Container>
      <Row>
        <Col sm={6}>
          <div className="Products Product__Wrap Product__Wrap_Target_Player">
            <p className="Products Product__Target">
              プレーヤー向け
            </p>
            <h2 className="Products Product__TitleWrap">
              <div>
              <p className="Products Product__Title Product__Title_Type_Main">河村勇輝の原点</p>
              <p className="Products Product__Title Product__Title_Type_Sub">～ガードのスキルと駆け引きを習得する～</p>
              </div>
            </h2>
            <div className="Products Product__Image">
              <Img fixed={query.jacketTV26.childImageSharp.fixed} />
            </div>
            <div className="Products Product__Link">
              <a href="https://paypaymall.yahoo.co.jp/store/japanlaim0418/item/tv29-s/?utm_source=lp&utm_medium=TV29">
                <i class="fab fa-dribbble"></i> 商品詳細はこちら<br/><span>paypayモール</span></a>
            </div>
            <div className="Products Product__DetailWrap">
              <div className="Products Product__Detail Product__Detail_Type_Peformer">
                <span className="Products Product__DetailTitle"><i class="fas fa-user-friends"></i> 出演</span>
                <ul>
                  <li>指導・解説：井手口  孝（福岡第一高等学校男子バスケットボール部 監督）</li>
                  <li>実技協力：河村 勇輝／福岡第一高等学校男子バスケットボール部</li>
                </ul>
              </div>
              <div className="Products Product__Detail Product__Detail_Type_Index">
                <span className="Products Product__DetailTitle"><i class="fas fa-list"></i> 収録内容</span>
                <ul>
                  <li>ブレイク</li>
                  <li>個人スキル</li>
                </ul>
                <p className="Products Product__DetailNote">※詳細は商品ページをご覧ください</p>
              </div>
              <div className="Products Product__Detail Product__Detail_Type_OthersWrap">
                <p className="Products Product__Detail Product__Detail_Type_ID">
                  <span className="Products Product__DetailTitle"><span className="icon">#</span> 商品番号</span> 
                  TV29-S
                </p>
                <p className="Products Product__Detail Product__Detail_Type_Disc">
                  <span className="Products Product__DetailTitle"><i class="fas fa-compact-disc"></i> 巻数</span>
                  全1巻
                </p>
                <div className="Products Product__Detail Product__Detail_Type_Price">
                  <span className="Products Product__DetailTitle"><i class="fas fa-yen-sign"></i> 値段</span>
                  <p>
                    <span className="proper">5,500円（税込・送料別）</span>
                    {/*
                    <span className="note">※3月30日（月）10:00　発売開始</span>
                    */}
                  </p>
                  {/*
                  <p>
                    <span className="discounted">予約：4,400円（税・送料込）</span>
                    <span className="discountTag"><i class="fas fa-tag"></i> 20%OFF</span>
                    <span className="note">※3月29日（日）23:59まで</span>
                  </p>
                  */}
                </div>
                <p className="Products Product__Detail Product__Detail_Type_Time">
                  <span className="Products Product__DetailTitle"><i class="far fa-clock"></i> 収録時間</span>
                  54分
                </p>
              </div>
            </div>
          </div>
        </Col>
        <Col sm={6}>
          <div className="Products Product__Wrap Product__Wrap_Target_Coach">
            <p className="Products Product__Target">
              コーチ向け
            </p>
            <h2 className="Products Product__TitleWrap">
              <div>
              <p className="Products Product__Title Product__Title_Type_Main">質の高いブレイクを生み出すガードの育成</p>
              <p className="Products Product__Title Product__Title_Type_Sub">～福岡第一が追求するスキルと駆け引き～</p>
              </div>
            </h2>
            <div className="Products Product__Image">
              <Img fixed={query.jacket1100.childImageSharp.fixed} />
            </div>
            <div className="Products Product__Link">
              <a href="https://www.japanlaim.co.jp/fs/jplm/gr2348/gd8827?utm_source=lp&utm_medium=1100">
                <i class="fab fa-dribbble"></i> 商品詳細はこちら<br/><span>ジャパンライム通販サイト</span></a>
            </div>
            <div className="Products Product__DetailWrap">
              <div className="Products Product__Detail Product__Detail_Type_Peformer">
                <span className="Products Product__DetailTitle"><i class="fas fa-user-friends"></i> 出演</span>
                <ul>
                  <li>指導・解説：井手口  孝（福岡第一高等学校男子バスケットボール部 監督）</li>
                  <li>実技協力：河村 勇輝／福岡第一高等学校男子バスケットボール部</li>
                </ul>
              </div>
              <div className="Products Product__Detail Product__Detail_Type_Index">
                <span className="Products Product__DetailTitle"><i class="fas fa-list"></i> 収録内容</span>
                <ul>
                  <li>ブレイク</li>
                  <li className="unique">合わせ</li>
                  <li>個人スキル</li>
                </ul>
                <p className="Products Product__DetailNote">※詳細は商品ページをご覧ください</p>
              </div>
              <div className="Products Product__Detail Product__Detail_Type_OthersWrap">
                <p className="Products Product__Detail Product__Detail_Type_ID">
                  <span className="Products Product__DetailTitle"><span className="icon">#</span> 商品番号</span> 
                  1100-S
                </p>
                <p className="Products Product__Detail Product__Detail_Type_Disc">
                  <span className="Products Product__DetailTitle"><i class="fas fa-compact-disc"></i> 巻数</span>
                  全1巻
                </p>
                <div className="Products Product__Detail Product__Detail_Type_Price">
                  <span className="Products Product__DetailTitle"><i class="fas fa-yen-sign"></i> 値段</span>
                  <p>
                    <span className="proper">8,800円（税込・送料別）</span>
                    {/*
                    <span className="note">※3月30日（月）10:00 発売開始</span>
                    */}
                  </p>
                  {/*
                  <p>
                    <span className="discounted">予約：7,040円（税・送料込）</span>
                    <span className="discountTag"><i class="fas fa-tag"></i> 20%OFF</span>
                    <span className="note">※3月29日 （日）23:59まで</span>
                  </p>
                  */}
                </div>
                <p className="Products Product__Detail Product__Detail_Type_Time">
                  <span className="Products Product__DetailTitle"><i class="far fa-clock"></i> 収録時間</span>
                  82分
                </p>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
  )

}

export default Products

